import { type RefObject, type SetStateAction, useCallback } from "react";
import { useResizable } from "@tellescope/ui";
import { useSidebarShallowStore, SIDEBAR_MAX_WIDTH, SIDEBAR_MIN_WIDTH } from "../../store/sidebar-store";

export const useSidebarPanel = (panelRef: RefObject<HTMLElement | null>) => {
  const {
    isOpen,
    width: storedWidth,
    setWidth,
    toggleIsOpen,
    setContentTypeData,
  } = useSidebarShallowStore("isOpen", "width", "setWidth", "toggleIsOpen", "setContentTypeData");

  const computeSize = useCallback((e: MouseEvent) => window.innerWidth - e.clientX, []);

  const { onDragStart } = useResizable({
    elementRef: panelRef,
    property: "width",
    computeSize,
    minSize: SIDEBAR_MIN_WIDTH,
    maxSize: SIDEBAR_MAX_WIDTH,
    onResizeEnd: setWidth,
    enabled: isOpen,
  });

  const setViewId = useCallback(
    (newVal: SetStateAction<string | undefined>) => {
      setContentTypeData((prev) => {
        const newViewId = typeof newVal === "function" ? newVal(prev.ContactDetails?.selectedViewId) : newVal;
        if (newViewId === prev.ContactDetails?.selectedViewId) return prev;
        return {
          ...prev,
          ContactDetails: {
            ...prev.ContactDetails,
            enduserId: prev.ContactDetails?.enduserId ?? "",
            selectedViewId: newViewId,
          },
        };
      });
    },
    [setContentTypeData]
  );

  return { isOpen, width: storedWidth, onDragStart, toggleIsOpen, setViewId };
};
